import { PDFViewer } from '@react-pdf/renderer';
import React from 'react';
import { Modal } from 'react-bootstrap';
import CetakSptPrimer from '../../../cetak/primer/CetakSptPrimer';

const ModalCetakSpt = ({showCetakSpt, handleCloseCetakSpt, rowData}) => {
    return (
        <>
            <Modal
                show={showCetakSpt}
                onHide={handleCloseCetakSpt}
                keyboard={false}
                scrollable={true}
                size='xl'
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        <CetakSptPrimer rowData={rowData} />
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCetakSpt